import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import s from './FeaturedTag.scss';
/** A featured indicator to be used when a comment has been featured. */ const FeaturedTag = ({ className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("span", {
        className: c(s['root'], className)
    }, t('comment.visibility.featuredV2'));
};
FeaturedTag.displayName = 'FeaturedTag';
export default FeaturedTag;
